<template>
  <section class="bet-card">
    <!-- Der Titel wird nur angezeigt, wenn die `showTitle`-Prop true ist. -->
    <h2 v-if="showTitle">Meine Einsätze in dieser Wette</h2>
    <div v-if="!myEnrichedBets || myEnrichedBets.length === 0" class="state-box">
        Keine Einsätze gefunden.
    </div>
    <table v-else class="stakes-table">
      <thead>
        <tr>
          <th>Position</th>
          <th class="align-right">Einsatz</th>
          <th class="align-right"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="entry in myEnrichedBets" :key="entry.id || JSON.stringify(entry)">
          <td>{{ entry.title }}</td>
          <td class="align-right">{{ entry.balance ?? entry.amount }} €</td>
          <!-- Sendet ein 'increase'-Event an die Elternkomponente, wenn der Button geklickt wird. -->
          <td class="align-right">
            <button type="button" class="increase-button" @click="$emit('increase', entry)">Einsatz Verdoppeln</button>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="total-stake"><strong>Mein Gesamt-Einsatz:</strong> {{ totalStake }} €</p>
  </section>
</template>

<script setup>

// Definiert die Eigenschaften (Props), die diese Komponente von außen akzeptiert.
defineProps({
  // Eine Liste der angereicherten Einsätze des Benutzers.
  myEnrichedBets: {
    type: Array,
    default: () => []
  },
  // Der Gesamteinsatz des Benutzers in dieser Wette.
  totalStake: {
    type: [String, Number],
    default: 0
  },
  // Steuert, ob der "Meine Einsätze..."-Titel angezeigt wird.
  showTitle: {
    type: Boolean,
    default: true
  }
})

// Definiert die Events, die diese Komponente aussenden kann.
// Hier wird das 'increase'-Event deklariert.
defineEmits(['increase'])
</script>

<style scoped lang="scss">
.bet-card {
  background: $card-background;
  border: 1px solid $border-color;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
}

.stakes-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;

  th,
  td {
    padding: 0.75rem;
    text-align: left;
    border-bottom: 1px solid $border-color;
  }

  th {
    font-weight: 600;
    opacity: 0.8;
  }

  .align-right {
    text-align: right;
  }
}

.total-stake {
  text-align: right;
  margin-top: 1rem;
  font-size: 1.1rem;
}

.increase-button {
  border: 1px solid $primary-color;
  background: transparent;
  color: $primary-color;
  border-radius: 999px;
  padding: 0.35rem 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: 0.15s ease;
  white-space: nowrap;

  &:hover {
    background: rgba($primary-color, 0.08);
  }

  &:active {
    transform: translateY(1px);
  }
}
</style>